import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoiApi } from './lib/api';
import { napTruoc } from './lib/du-lieu';
import { App } from './App';
import './index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      // 401/403 không thử lại — thử lại chỉ làm chậm màn hình đăng nhập / báo lỗi quyền.
      retry: (lan, e) => !(e instanceof LoiApi && e.ma < 500) && lan < 2,
    },
  },
});

// Dữ liệu lõi bắt đầu tải NGAY, song song với /api/toi và với chunk của trang (xem lib/du-lieu.ts).
napTruoc(qc);

// PWA: chỉ đăng ký ở bản build (dev server của Vite không cần, và SW cũ sẽ che thay đổi khi đang sửa code).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => null));
}

createRoot(document.getElementById('goc')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
